"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.payerContractStatusTypes = exports.PayerContractUtil = void 0;
var _ = require("./");
var isStateSatisfiesPayerContract = function isStateSatisfiesPayerContract(state, payerContract) {
  var geography = payerContract.geography;
  if (!state) {
    return false;
  }
  if (geography === _.NATIONAL_PAYER_CONTRACTS_OPTION && !_.EXCLUDED_PAYER_CONTRACTS_STATES.includes(state)) {
    return true;
  }
  return geography === state;
};
var PayerContractUtil = {
  isStateSatisfiesPayerContract: isStateSatisfiesPayerContract
};
exports.PayerContractUtil = PayerContractUtil;
var payerContractStatusTypes = {
  Archived: 'archived',
  Complete: 'complete',
  InProgress: 'in-progress',
  Pending: 'pending',
  Terminated: 'terminated'
};
exports.payerContractStatusTypes = payerContractStatusTypes;